import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';

export const getEventMexicoPromo = createAsyncThunk(
  'event/getMexicoEvents',
  async () => {
    const { data } = await axios.get(`/bonus/mexico-promotion/info`);

    return data.data as Event;
  }
);

export const getEventDubaiPromo = createAsyncThunk(
  'event/getEventDubaiPromo',
  async () => {
    const { data } = await axios.get(`/bonus/dubai-promotion/info`);

    return data.data;
  }
);

export const getEventBangkokPromo = createAsyncThunk(
  'event/getBangkokEvents',
  async () => {
    const { data } = await axios.get(`/bonus/bangkok-promotion/info`);

    return data.data as Event;
  }
);

export const getEventCruisesPromo = createAsyncThunk(
  'event/getCruisesEvents',
  async () => {
    const { data } = await axios.get(`/bonus/cruises-promotion/info`);

    return data.data as Event;
  }
);

interface PersonalSalesProgress {
  required: number;
  percentage: number;
  showThumb: boolean;
}

interface Tier {
  name: string;
  hasConditionForTier: boolean;
  reward: string;
  personalSalesProgress: PersonalSalesProgress;
  directVolumeProgress: PersonalSalesProgress;
  paidTeamProgress: PersonalSalesProgress;
}

interface Event {
  tiers: Tier[];
  startDate: string;
  endDate: string;
  personalSalesAmount: number;
  directVolumeAmount: number;
  paidTeamAmount: number;
}

interface Progress {
  current: number;
  required: number;
  percentage: number;
}

export interface UserProgress {
  rankName: string;
  paidTeam: Progress;
  directVolume: Progress;
  strongTeam: Progress;
  personalOrder: Progress;
  businessVolume: Progress;
}

export interface eventSliceType {
  loading: boolean;
  events: Event;
}

const initialState = {
  loading: false,
  events: {}
} as eventSliceType;

const eventSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    //Dubai
    builder.addCase(getEventDubaiPromo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventDubaiPromo.fulfilled, (state, { payload }) => {
      state.loading = false;

      state.events = payload;
    });
    builder.addCase(getEventDubaiPromo.rejected, (state) => {
      state.loading = false;
    });
    //Mexico
    builder.addCase(getEventMexicoPromo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventMexicoPromo.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.events = payload;
    });
    builder.addCase(getEventMexicoPromo.rejected, (state) => {
      state.loading = false;
    });

    //Bangkok
    builder.addCase(getEventBangkokPromo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventBangkokPromo.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.events = payload;
    });
    builder.addCase(getEventBangkokPromo.rejected, (state) => {
      state.loading = false;
    });

    //Cruises

    builder.addCase(getEventCruisesPromo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventCruisesPromo.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.events = payload;
    });
    builder.addCase(getEventCruisesPromo.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default eventSlice.reducer;
